import React from "react";
import { Link, NavLink } from "react-router-dom";

import ModelBadge, { ModelOptionsType } from "./ModelBadge";

interface SecondaryNavProps {
  children?: React.ReactNode;
  className?: string;
}

const SecondaryNav: React.FC<SecondaryNavProps> = ({
  children,
  className = "bg-dark px-3 mb-3",
}) => {
  return (
    <div className={`d-print-none ${className}`}>
      <nav className="nav nav-underline">{children}</nav>
    </div>
  );
};

interface SecondaryNavModelTitleProps {
  to: string;
  modelTo: string;
  title?: string;
  model?: keyof ModelOptionsType;
}

export const SecondaryNavModelTitle: React.FC<SecondaryNavModelTitleProps> = ({
  to,
  modelTo,
  title,
  model,
}) => {
  return (
    <div className="d-flex align-items-center mr-2">
      <div>
        <Link to={modelTo}>
          <ModelBadge model={model as any} />
        </Link>
      </div>
      <h1 className="h5 mb-0">
        <NavLink className="nav-link" to={to}>
          {title || <span>&nbsp;</span>}
        </NavLink>
      </h1>
    </div>
  );
};

interface SecondaryNavTitleProps {
  title?: React.ReactNode;
  model?: keyof ModelOptionsType;
}

export const SecondaryNavTitle: React.FC<SecondaryNavTitleProps> = ({
  title,
  model = null,
}) => (
  <div className="d-flex align-items-center">
    {model && (
      <div>
        <ModelBadge model={model} />
      </div>
    )}
    <h1 className="h5 nav-link mb-0 text-light">{title}</h1>
  </div>
);

export default SecondaryNav;
